export function getItemsArray({ sort=[], items={} }) {
    return sort.map(id => items[id])
}

export function getUserTimeEntries(timeEntries, userId) {
    const timeEntriesArray = getItemsArray(timeEntries)
    return timeEntriesArray.filter(item => item.userId === userId)
}


// WEBPACK FOOTER //
// ./src/util/prop_utils.js